import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { pluck } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { ResetPasswordInterface } from './reset-password.interface';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  hash: string;
  resetPassword$: Observable<boolean>;
  done = false;
  fieldErrors: any;

  constructor(
    private authService: AuthService,
    private activeRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.hash = this.activeRoute.snapshot.params['hash'];
    this.resetPassword$ = this.activeRoute.data.pipe(pluck('resetPassword'));
  }

  async onResetPassword(resetPassword: ResetPasswordInterface) {
    this.fieldErrors = null;
    try {
      await this.authService.resetPassword(this.hash, resetPassword.password, resetPassword.passwordRepeat);
      this.done = true;
    } catch (errors) {
      this.fieldErrors = errors;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/reset-password/reset-password.component.ts